export const selectSessionAuthToken = state => state.session.aut;
export const selectHasSessionUser = state => !!state.session.aut;
export const selectSessionQuery = state => state.session.qstr || null;
export const selectPlatformUser = state =>
  state.user ? state.user.currentMembership.user : null;
